import React, { useState } from 'react';
import { href, Link, useHref, useLocation } from 'react-router-dom';
import './CardSection.css';

interface ExpandedCards {
  [key: number]: boolean;
}

interface Card {
  image: string;
  title: string;
  description?: string;
  url?: string;
}

const CardSection = ({ title, description, cards }: { title: string; description: string; cards: Card[] }) => {
  const [expandedCards, setExpandedCards] = useState<ExpandedCards>({});
  
  const renderCard = (card:Card, index:number) => {
    return (
      <div className="card" key={index} >
        <img src={card.image} alt={card.title} className="card-image" />
        <h3>{card.title}</h3>
        {card?.description && (
          <p className="card-description">
          {isDescriptionLong(card.description) && !expandedCards[index]
            ? getShortenedDescription(card.description)
            : card.description}
        </p>
        )}
        <a
            className="read-more-button"
            
          >
            Learn More
          </a>
      </div>
    )
  }

  const toggleCardDescription = (cardIndex: number) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardIndex]: !prev[cardIndex],
    }));
  };

  const isDescriptionLong = (desc: string) => {
    return desc.split(' ').length > 100;
  };

  const getShortenedDescription = (desc: string) => {
    const words = desc.split(' ');
    return words.slice(0, 30).join(' ') + '...';
  };

  return (
    <section className="card-section">
      <div className="section-content">
        <div className="section-header">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="card-grid">
          {cards.map((card: Card, index: number) => ( // Specify type of card here
            card?.url ? (
              <Link to={card.url}>
                {renderCard(card, index)}
              </Link>
            ) : (
              renderCard(card, index)
            )
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardSection;